import { render, staticRenderFns } from "./ModalPdfViewer.vue?vue&type=template&id=9263154a&scoped=true"
import script from "./ModalPdfViewer.vue?vue&type=script&lang=js"
export * from "./ModalPdfViewer.vue?vue&type=script&lang=js"
import style0 from "./ModalPdfViewer.vue?vue&type=style&index=0&id=9263154a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9263154a",
  null
  
)

export default component.exports